import { Injectable } from '@angular/core';
import { PlatformProfile } from "../model/platformprofile";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {User} from "../model/user";
import {SavedProperty} from "../model/savedProperty";

@Injectable()
export class PlatformService {

  constructor(private http:HttpClient) {
  }

  public getPlatformprofile(headers: any, oView: string = 'PLATFORM_CONNECT_BASE_VIEW') {
    let httpOptions = { }
    if(headers) {
      httpOptions = {
        headers: headers
      }
    }
    return this.http.get<PlatformProfile>(`/api/platform/profile?oView=${oView}`, httpOptions);
  }

  public getLogos(subDomain:string){
    return this.http.get("/api/platform/system/logo/" + subDomain)
  }

  public getLogins(subDomain:string){
    return this.http.get("/api/platform/system/logins/" + subDomain);
  }

  public uploadNewMandate(id: number, name: string, file){
    const formData: FormData = new FormData();
    formData.append("file",file)
    formData.append("name",name)
    return this.http.post("/api/platform/" + id + "/mandate",formData);

  }

    /**
     * Gets all users for a specific platform specified by its id
     *
     * @param id Id of a platform profile for which the users should be gotten
     * @param headers headers containing the logon id of a multi user
     * @return Observable of an array of all found users for a platform profile
     */
  public getUsersByPlatformId(id: number, headers: any): Observable<User[]>{
      const httpOptions = {
          withCredentials: true,
          headers: headers
      }
      return this.http.get<User[]>("/api/multi-user/platform/" + id + "/users", httpOptions);
  }

    /**
     * Gets all saved properties for a specific platform profile specified by its id
     *
     * @param id Id of the platform profile for which the saved properties should be gotten
     * @param headers Headers containing the loginId for a multi user
     */
  public getSavedPropertiesByPlatformId(id: number, headers: any): Observable<SavedProperty[]>{
      const httpOptions = {
          withCredentials: true,
          headers: headers
      }

      return this.http.get<SavedProperty[]>("/api/platform/" + id + "/saved-properties", httpOptions);
  }

}
